import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-url-source',
  templateUrl: './btn-url-source.component.html',
  styleUrls: ['./btn-url-source.component.css']
})
export class BtnUrlSourceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
